/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { openDialog, closeDialog } from "../../store/BASE/dialogSlice";
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";
import Button from "@mui/material/Button";
import { useDispatch } from "react-redux";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";


const DeleteModal = (props) => {
  const dispatch = useDispatch();
  const { onDelete, resource } = props;

  return (
    <Button
      className="mr-8"
      onClick={()=> dispatch(openDialog({
        children: (
          <>
            <DialogTitle 
              id="alert-dialog-title"
              className="text-lg font-semibold"
              sx={{ 
                display: "flex",
                alignItems: "center",
                backgroundColor: "error.main",
                color: "error.contrastText"
              }}
            >
              <BASESvgIcon className="mr-8" size={20}>
                heroicons-outline:exclamation
              </BASESvgIcon>
              Confirm Delete
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" className="pt-16">
                  Are you sure you want to delete this {resource}? This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={()=> dispatch(closeDialog())} color="primary">
                    Cancel
                </Button>
                <Button 
                  onClick={() => {
                    onDelete();
                    dispatch(closeDialog());
                  }}
                  color="error"
                  autoFocus
                >
                    Delete
                </Button>
            </DialogActions>
          </>
        )
      }))}
      variant="contained"
      color="error"
      startIcon={
        <BASESvgIcon className="" size={20}>
          heroicons-outline:trash
        </BASESvgIcon>
      }
    >
      Delete
    </Button>
  );
};

export default DeleteModal;
